// extracted by mini-css-extract-plugin
export default {"container":"IconWithLabel_container__zzhMr","containerSelected":"IconWithLabel_containerSelected__ChuHY","labelText":"IconWithLabel_labelText__Mme1S"};